<div>
  <h6 *ngIf="header" class="list-heading">{{ header }}</h6>
  <ul class="dynamic-list">
    <li
      *ngFor="let item of dynamicList"
      class="dynamic-list-item d-flex justify-content-between"
      (click)="emitListItemData(item)"
    >
      {{ item?.title }}
      <em class="icon-litedrop-down-icon rotate-90"></em>
    </li>
  </ul>
</div>
